import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Star } from 'lucide-react';
const REVIEWS = [{
  name: 'Valentina R.',
  text: 'Compré este diario en mi semana 12 y ha sido la experiencia más hermosa. Las preguntas me hacen reflexionar y conectarme con mi bebé de una forma que no imaginaba. Lloro de emoción cada vez que escribo.',
  week: 'Semana 28'
}, {
  name: 'Sofía M.',
  text: 'El mejor regalo que me he hecho en el embarazo. Me sentía muy desconectada por el estrés del trabajo, pero el ritual nocturno cambió todo. Ahora es nuestro momento especial del día.',
  week: 'Semana 34'
}, {
  name: 'Camila G.',
  text: 'La calidad es hermosa y el contenido es tan profundo. Saber que mi hija leerá estas cartas cuando sea grande me llena el corazón. Totalmente recomendado para cualquier futura mamá.',
  week: 'Semana 16'
}];
export function Testimonials() {
  return <section id="testimonios" className="bg-brand-cream-alt py-20 border-y border-brand-gold/20" data-id="element-193">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <FadeIn data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-brand-burgundy mb-12" data-id="element-196">
            Lo que dicen otras mamás
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-197">
          {REVIEWS.map((review, idx) => <FadeIn key={idx} delay={idx * 0.2} data-id="element-198">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-brand-gold/10 h-full flex flex-col" data-id="element-199">
                <div className="flex text-brand-gold mb-4" data-id="element-200">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-201" />)}
                </div>
                <p className="text-gray-700 italic mb-6 flex-1" data-id="element-202">
                  "{review.text}"
                </p>
                <div className="flex items-center justify-between border-t border-gray-100 pt-4 mt-auto" data-id="element-203">
                  <span className="font-semibold text-brand-burgundy" data-id="element-204">
                    {review.name}
                  </span>
                  <span className="text-xs text-brand-rose font-medium bg-brand-rose-light/10 px-2 py-1 rounded-full" data-id="element-205">
                    {review.week}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}